<template>
	<BaseSingleSelect
		:searchable="true"
		:placeholder="
			!term.multi
				? `Alle borgere`
				: props.isAll
					? `Alle ${term.multi}`
					: `Vælg ${term.single}`
		"
		:options="newOptions"
		:isCategories="isCategories"
		@option:selected="($event) => $emit('change', $event)"
	></BaseSingleSelect>
</template>
<script setup>
import { ref, onBeforeMount, watch, watchEffect } from "vue";
import BaseSingleSelect from "@elements/select/BaseSingleSelect.vue";
import Service from "@services/StudentService";
import DepartmentService from "@services/DepartmentService";
import { studentTerm } from "../../../../helpers/TermHelper";

const props = defineProps({
	isAll: {
		type: Boolean,
		default: true,
		required: false,
	},
	isCategories: Boolean,
	studentId: {
		type: Number,
		default: null,
		required: false,
	},
	department: String,
	userDeps: {
		type: Array,
		default: [],
		required: false,
	},
	term: String,
	options: Array,
});

const newOptions = ref([]);

const term = ref(props.term || "");

watch(
	() => props.department,
	(newVal, oldVal) => {
		if (newVal !== oldVal && oldVal !== undefined) {
			newOptions.value = [];
			populateOptions();
		}
	},
);

onBeforeMount(async () => {
	term.value = await studentTerm();
	await populateOptions();
});

watchEffect(() => {
	if (Array.isArray(props.options)) {
		newOptions.value = props.options
	}
})

const populateOptions = async () => {
	if (Array.isArray(props.options) && props.options.length > 0) return

	const service = new Service();
	let students = await service.getAll();
	if (props.isAll) {
		newOptions.value.push({
			label: !term.value.multi
				? `Alle borgere`
				: `Alle ${term.value.multi}`,
			option: "",
		});
	}
	if (props.studentId) {
		students = students.filter(
			(student) => student.student_id === props.studentId,
		);
	}
	students = students.filter((student) => student.user_status != "archive");
	if (props.department) {
		students = students.filter(
			(student) =>
				student.department_ids.includes(props.department.option) ||
				student.department_ids.includes("all"),
		);
	}
	if (props.userDeps.length > 0) {
		students = students.filter((student) =>
			props.userDeps.some(
				(depId) =>
					student.department_ids.includes(depId.toString()) ||
					student.department_ids.includes("all"),
			),
		);
	}
	for (const student of students) {
		const option = {
			label: `${student?.fname} ${student?.lname}`,
			option: student.student_id,
		};
		newOptions.value.push(option);
	}
};
defineExpose({ options: newOptions });
</script>
